import { CardRec, CardStats } from '@/components/common/Card'
import { type RecType } from '@/defs/rec'
import { type StatType } from '@/defs/stat'
import { cn } from '@/utils/commonUtil'

import styles from './FeaturedRecPartners.module.scss'
import { FeaturedRecPartnersChooser } from './FeaturedRecPartnersChooser/FeaturedRecPartnersChooser'

type Props = {
  rec: RecType
  stats?: StatType[]
}

export const FeaturedRecPartners = ({ rec, stats }: Props) => {
  const { partnerRef } = rec
  const isChooser = !partnerRef
  const showStats = !isChooser && !!stats?.length

  return (
    <div className={cn(styles.container, { isChooser, styles })}>
      {!isChooser && (
        <div className={styles.stacked}>
          <CardRec controls='none' disableLink rec={rec} />
        </div>
      )}
      <div className={styles.pair}>
        <div className={styles.back}>
          {isChooser ? (
            <FeaturedRecPartnersChooser />
          ) : (
            <CardRec disableLink extend rec={{ ...rec, onlyPartner: 'second' }} />
          )}
        </div>
        <div className={styles.front}>
          <CardRec
            controls={isChooser ? 'left' : 'none'}
            disableLink
            extend={isChooser}
            rec={{ ...rec, onlyPartner: 'first' }}
            stats={isChooser ? stats : undefined}
          />
        </div>
      </div>
      {showStats && (
        <div className={styles.stats}>
          <CardStats isInView rec={rec} stats={stats} />
        </div>
      )}
    </div>
  )
}
